exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs[data-v-8c861d04]{display:-ms-flexbox;display:flex;gap:10px;-ms-flex-wrap:wrap;flex-wrap:wrap;text-transform:uppercase;margin-bottom:10px;font-size:12px;font-weight:700}.tabs .tab[data-v-8c861d04]{cursor:pointer}.tabs .tab.selected[data-v-8c861d04],.tabs .tab[data-v-8c861d04]:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8c861d04","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/vacancy/Vacancy.vue
// module id = 8be70bf8e045c71e3120
// module chunks = 53